import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { grey } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Stack, Typography } from '@mui/material';

import { DealSheetRulesTableRow } from '../../types';

interface Props<Key extends keyof DealSheetRulesTableRow> {
  ruleKey: Key;
  rule: DealSheetRulesTableRow;
  formatter?: (value: DealSheetRulesTableRow[Key]) => ReactNode;
}

export const RuleValue = <Key extends keyof DealSheetRulesTableRow>({ rule, ruleKey, formatter }: Props<Key>) => {
  const classes = useStyles();

  if (!rule[ruleKey]) {
    return (
      <Box className={clsx(classes.container, classes.emptyContainer)}>
        <Typography variant="body2">Any</Typography>
      </Box>
    );
  }

  if (Array.isArray(rule[ruleKey])) {
    return (
      <Stack gap="0.5rem" width="100%" alignItems="flex-start">
        {rule[ruleKey].map(value => (
          <Box key={value} className={classes.container}>
            <Typography variant="body2">{formatter ? formatter(value) : value}</Typography>
          </Box>
        ))}
      </Stack>
    );
  }

  return (
    <Box className={classes.container}>
      <Typography variant="body2">{formatter ? formatter(rule[ruleKey]) : rule[ruleKey]}</Typography>
    </Box>
  );
};

const useStyles = makeStyles(({ shadows }) => ({
  container: {
    padding: '2px 8px',
    borderRadius: '4px',
    width: 'fit-content',
    boxShadow: shadows[1],
    backgroundColor: grey['A100'],
  },
  emptyContainer: {
    opacity: 0.5,
  },
}));
